import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class CashRegisterService {
    SearchCashRegisters = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters)
        return await HttpClient.Get(`/api/cashRegisters?${queryString}`);
    }

    SearchMovements = async (pageSize, pageNumber, filters, branchId) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            pageSize,
            pageNumber,
            branchId
        })
        return await HttpClient.Get(`/api/cashRegisters/movements?${queryString}`);
    }

    Get = async (cashRegisterId) =>
        await HttpClient.Get(`/api/cashRegisters/${cashRegisterId}`)

    GetTotals = async (cashRegisterId) =>
        await HttpClient.Get(`/api/cashRegisters/${cashRegisterId}/totals`)

    GetMonthlyImprest = async (branchId) =>
        await HttpClient.Get(`/api/cashRegisters/${branchId}/totalsCash`);

    SearchMovementReasons = async ( filters ) => {
        const queryString = utils.GetQueryStringsFromObject( filters )
        return await HttpClient.Get(`/api/cashRegisters/movementReasons?${queryString}`);
    }

    CreateMovement = async (movement) =>
        await HttpClient.Post(`/api/cashRegisters/movement`, movement, null);

    UpdateMovementFileUrl = async (movementId, fileUrl) =>
        await HttpClient.Put(`/api/cashRegisters/movement/${movementId}/fileUrl`, { fileUrl }, null);

    CreateClosure = async (cashRegisterId, archingDetails, userEmail) =>
        await HttpClient.Post(`/api/closures`, { cashRegisterId, details: archingDetails, userEmail }, null);

    createTransferMovement = async (cashRegisterIdOrigen, movement) =>
        await HttpClient.Post(`/api/cashRegisters/${cashRegisterIdOrigen}/transfer`, movement, null);

    GetPaymentMethodSummary = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters);
        return await HttpClient.Get(`/api/cashRegisters/paymentMethodSummary?${queryString}`);
    }

    GetDepositReceipt = async (movementId) =>
        await HttpClient.GetText(`/api/cashRegisters/${movementId}/DepositReceipt`)
}

export default new CashRegisterService();